import { IMetadata } from './metadata';
import { Project } from './project';
import { TaskStatus } from './task-status';

export const taskIdKey: keyof Task = 'id';
export const taskDesignIdKey: keyof Project = 'projectId';

export class Task {
  public constructor(
    public id: string,
    public sortNumber: string,
    public process: string,
    public processText: string,
    public projectGuid: string,
    public taskGuid: string,
    public taskLevel: string,
    public objectType: string,
    public explanation: string,
    public status: TaskStatus,
    public fixedStartConstraintType: string,
    public fixedStartConstraintText: string,
    public fixedStartDate: Date | undefined,
    public fixedFinishConstraintType: string,
    public fixedFinishConstraintText: string,
    public fixedFinishDate: Date | undefined,
    public calculatedEarlyStartDate: Date | undefined,
    public calculatedEarlyFinishDate: Date | undefined,
    public calculatedLateStartDate: Date | undefined,
    public calculatedLateFinishDate: Date | undefined,
    public actualStartDate: Date | undefined,
    public actualFinishDate: Date | undefined,
    public forecastedStart: Date | undefined,
    public forecastedFinish: Date | undefined,
    public readonly metadata: IMetadata | undefined
  ) {}
}
